import { Institucion } from './saci/institucion.model';

export default class BusquedaInstitucionFactory {
  public static getDefaultCatalogo(): any {
    return {
      id: null,
      nombre: '',
    };
  }

  public static getDefaultCatalogoClave(): any {
    return {
      id: null,
      clave: null,
      nombre: '',
    };
  }

  public static getDefaultCatalogoClaveInstitucion(): any {
    return {
      //id: diez-mil para institución - manual e ingManInst para ingresoManualInstitucion
      id: 10000,
      clave: 'ingManInst',
      nombre: '',
    };
  }
  public static getDefaultPublicaPrivada(): any {
    return {
      id: null,
      nombre: '',
      id2: null,
      nombre2: '',
    };
  }
  public static setInstitucion(): any {
    return {
      buscadorInstitucion: '',
      tipoInstitucion: {
        id: '01',
        nombre: 'Nacional',
      },
      publicaPrivada: this.getDefaultPublicaPrivada(),
      pais: this.getDefaultCatalogo(),
      entidad: this.getDefaultCatalogoClave(),
      municipio: this.getDefaultCatalogoClave(),
      institucion: this.getDefaultCatalogoClave(),
      institucionManual: this.getDefaultCatalogoClaveInstitucion(),
    };
  }

  public static getInstitucionModel(): Institucion {
    return {
      id: null,
      clave: null,
      nombre: null,
      tipo: null,
      pais: null,
      entidad: null,
      municipio: null,
      nivelUno: null,
      nivelDos: null,
    };
  }

  public static getTipoPublicaPrivada(translateFunction: (key: string) => string): any {
    return [
      {
        value: { id: '01', nombre: 'Pública', id2: '01', nombre2: 'Federal' },
        text: translateFunction('busqueda-institucion.forms.publica-privada.federal'),
      },
      {
        value: { id: '01', nombre: 'Pública', id2: '02', nombre2: 'Estatal' },
        text: translateFunction('busqueda-institucion.forms.publica-privada.estatal'),
      },
      {
        value: { id: '01', nombre: 'Pública', id2: '03', nombre2: 'Municipal' },
        text: translateFunction('busqueda-institucion.forms.publica-privada.municipal'),
      },
      {
        value: { id: '02', nombre: 'Privada', id2: '', nombre2: '' },
        text: translateFunction('busqueda-institucion.forms.publica-privada.privada'),
      },
    ];
  }
}
